/**
 * Mock vendor notifications for UI development (read / unread / archived mix).
 */
export const initialVendorNotifications = [
  {
    id: 1,
    date: "10/01/2025",
    title: "Aggiornamento catalogo completato",
    description:
      "Il caricamento automatico del catalogo e terminato con successo. Sono stati importati 1.240 prodotti e aggiornati 86 record esistenti. Puoi verificare i dettagli nella sezione Caricamenti.",
    isRead: false,
    archived: false,
  },
  {
    id: 2,
    date: "08/01/2025",
    title: "Saldo ricariche in esaurimento",
    description:
      "Il tuo saldo disponibile per le campagne e inferiore alla soglia consigliata. Ti invitiamo ad effettuare una ricarica per evitare interruzioni nella pubblicazione dei prezzi.",
    isRead: false,
    archived: false,
  },
  {
    id: 3,
    date: "05/01/2025",
    title: "Manutenzione programmata",
    description:
      "Domenica 12 gennaio dalle 02:00 alle 04:00 potrebbero verificarsi brevi interruzioni del servizio per aggiornamenti infrastrutturali.",
    isRead: true,
    archived: false,
  },
  {
    id: 4,
    date: "02/01/2025",
    title: "Nuova funzione: filtri avanzati",
    description:
      "E ora disponibile il filtro per fascia di prezzo nella pagina Prodotti. Provalo per affinare la ricerca nel tuo catalogo.",
    isRead: true,
    archived: false,
  },
  {
    id: 5,
    date: "15/12/2024",
    title: "Promozione di fine anno",
    description:
      "Messaggio promozionale archiviato. La campagna e conclusa; puoi ripristinare la notifica se ti serve ancora come riferimento.",
    isRead: true,
    archived: true,
  },
  {
    id: 6,
    date: "01/12/2024",
    title: "Avviso privacy aggiornato",
    description:
      "Versione archiviata dell avviso privacy. Consulta la versione corrente nella sezione dedicata.",
    isRead: true,
    archived: true,
  },
];
